export default __webpack_public_path__ + "static/media/esther.0b777d53.png";